// Error Test Component
// Only for development - helps test error handling
// Access by adding ?test-errors to the URL (e.g., http://localhost:3000?test-errors)

import React, { useState } from 'react';

function ErrorTest() {
  const [shouldThrow, setShouldThrow] = useState(false);

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  // Trigger React error
  if (shouldThrow) {
    throw new Error('Test Error: This is a simulated error for testing error boundaries!');
  }

  const triggerRenderError = () => {
    setShouldThrow(true);
  };

  const triggerConsoleError = () => {
    console.error('Test Console Error: This appears in browser console');
  };

  const triggerAsyncError = () => {
    setTimeout(() => {
      throw new Error('Test Async Error: This is an unhandled promise rejection');
    }, 100);
  };

  const triggerNetworkError = async () => {
    try {
      await fetch('https://invalid-url-that-does-not-exist-12345.com');
    } catch (error) {
      console.error('Test Network Error:', error);
      alert('Network error triggered (check console)');
    }
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
      zIndex: 9999,
      border: '2px solid #e99c7e',
      minWidth: '300px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '15px'
      }}>
        <h3 style={{ 
          margin: 0,
          color: '#e99c7e',
          fontSize: '16px',
          fontWeight: '600'
        }}>
          🧪 Error Testing Panel
        </h3>
        <span style={{
          fontSize: '12px',
          color: '#666',
          backgroundColor: '#222',
          padding: '4px 8px',
          borderRadius: '4px'
        }}>
          DEV ONLY
        </span>
      </div>
      
      <p style={{
        fontSize: '12px',
        color: '#999',
        marginBottom: '15px',
        lineHeight: '1.4'
      }}>
        Test different error scenarios to see how the app handles them.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <button
          onClick={triggerRenderError}
          style={buttonStyle('#ff6b6b')}
          onMouseOver={(e) => e.target.style.opacity = '0.8'}
          onMouseOut={(e) => e.target.style.opacity = '1'}
        >
          ❌ Trigger React Error
        </button>

        <button
          onClick={triggerConsoleError}
          style={buttonStyle('#ffd93d')}
          onMouseOver={(e) => e.target.style.opacity = '0.8'}
          onMouseOut={(e) => e.target.style.opacity = '1'}
        >
          ⚠️ Console Error
        </button>

        <button
          onClick={triggerAsyncError}
          style={buttonStyle('#ff9966')}
          onMouseOver={(e) => e.target.style.opacity = '0.8'}
          onMouseOut={(e) => e.target.style.opacity = '1'}
        >
          ⏱️ Async Error
        </button>

        <button
          onClick={triggerNetworkError}
          style={buttonStyle('#6bcbff')}
          onMouseOver={(e) => e.target.style.opacity = '0.8'}
          onMouseOut={(e) => e.target.style.opacity = '1'}
        >
          🌐 Network Error
        </button>
      </div>

      <div style={{
        marginTop: '15px',
        padding: '10px',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '4px',
        fontSize: '11px',
        color: '#666',
        lineHeight: '1.5'
      }}>
        <p style={{ margin: '0 0 8px 0' }}>
          💡 <strong>Tip:</strong> Remove <code>?test-errors</code> from URL to hide this panel.
        </p>
        <p style={{ margin: '0', fontSize: '10px', opacity: 0.8 }}>
          Note: React Error will show your custom purple warning box overlaying the page.
        </p>
      </div>
    </div>
  );
}

const buttonStyle = (color) => ({
  backgroundColor: color,
  color: '#000',
  border: 'none',
  padding: '10px 16px',
  fontSize: '14px',
  fontWeight: '600',
  borderRadius: '6px',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  textAlign: 'left'
});

export default ErrorTest;

